"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkeletonRowItem = exports.StyledCardSkeletonBox = void 0;
const theme_1 = require("@icr-ui/theme");
const styled_components_1 = __importDefault(require("styled-components"));
const col_1 = require("../col");
exports.StyledCardSkeletonBox = (0, styled_components_1.default)(col_1.Col) `
  justify-content: flex-start;
  margin-bottom: 24px;
`;
const skeleton = styled_components_1.default.div `
  background: linear-gradient(
    90deg,
    ${theme_1.grayScale[300]} 0%,
    ${theme_1.grayScale[100]} 36.66%,
    ${theme_1.grayScale[300]} 100%
  );
  background-size: 400% 400%;
  animation: shimmer 1.2s ease-in-out infinite;

  @keyframes shimmer {
    0% {
      background-position: 0% 0%;
    }
    100% {
      background-position: -135% 0%;
    }
  }
`;
exports.SkeletonRowItem = (0, styled_components_1.default)(skeleton) `
  width: ${({ width }) => width};
  height: 8px;
  border-radius: 8px;
`;
//# sourceMappingURL=styles.js.map